import { useContext, useMemo } from 'react';

import { MultiStepContext, multistepContext } from './MultiStepProvider';

export const useMultiStep = <TValues extends object>() => {
  const multiStep = useContext(multistepContext);
  return useMemo(() => multiStep as MultiStepContext<TValues>, [multiStep]);
};
